import {Web3} from "web3";
let isItConnected = false;
const networks = {
  opbnb: {
    chainId: `0x${Number(204).toString(16)}`, // opBNB Mainnet Chain ID: 204
    chainName: "opBNB Mainnet",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18,
    },
    rpcUrls: [
      "https://opbnb-mainnet-rpc.bnbchain.org",
      "https://opbnb-mainnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3",
      "https://opbnb-mainnet.nodereal.io/v1/e9a36765eb8a40b9bd12e680a1fd2bc5",
      "https://opbnb.publicnode.com",
      "https://1rpc.io/opbnb",
      "https://opbnb-rpc.publicnode.com",
    ],
    wsUrls: [
      "wss://opbnb-mainnet-rpc.bnbchain.org",
      "wss://opbnb.publicnode.com",
    ],
    blockExplorerUrls: ["https://opbnbscan.com"],
  },
};
const changeNetwork = async ({ networkName }) => {
  try {
    if (!window.ethereum) throw new Error("No crypto wallet found");
    await window.ethereum.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          ...networks[networkName],
        },
      ],
    });
  } catch (err) {
  }
};
const handleNetworkSwitch = async (networkName) => {
  await changeNetwork({ networkName });
};

// Optimized RPC connection with timeout and priority
const createWeb3WithRetry = async (networkName = "opbnb", timeout = 5000) => {
  const network = networks[networkName];
  let web3Instance = null;
  
  // If MetaMask is available, use it
  if (window.ethereum) {
    return new Web3(window.ethereum);
  }
  
  // Priority RPC URLs (fastest ones first)
  const priorityRPCs = [
    "https://opbnb-mainnet-rpc.bnbchain.org",
    "https://opbnb.publicnode.com",
    "https://1rpc.io/opbnb"
  ];

  // Try priority RPCs first with short timeout
  for (const rpcUrl of priorityRPCs) {
    try {
      const httpProvider = new Web3.providers.HttpProvider(rpcUrl, {
        timeout: timeout
      });
      web3Instance = new Web3(httpProvider);
      
      // Quick connection test with timeout
      const testPromise = web3Instance.eth.getBlockNumber();
      const timeoutPromise = new Promise((_, reject) => 
        setTimeout(() => reject(new Error('Connection timeout')), timeout)
      );
      
      await Promise.race([testPromise, timeoutPromise]);
      console.log(`✅ Fast connected to: ${rpcUrl}`);
      return web3Instance;
    } catch (error) {
      console.warn(`⏭️ Skipping ${rpcUrl}: ${error.message}`);
    }
  }

  // If priority RPCs fail, use first available from full list
  try {
    const httpProvider = new Web3.providers.HttpProvider(network.rpcUrls[0]);
    web3Instance = new Web3(httpProvider);
    console.log(`🔄 Fallback to: ${network.rpcUrls[0]}`);
    return web3Instance;
  } catch (error) {
    throw new Error(`🚫 All RPC connections failed: ${error.message}`);
  }
};
let accounts;
const getAccounts = async () => {
  const web3 = window.web3;
  try {
    accounts = await web3.eth.getAccounts();
    return accounts;
  } catch (error) {
    return null;
  }
};
// Helper function to get the best available Web3 instance
export const getWeb3Instance = () => {
  if (window.ethereum) {
    // Create a new Web3 instance with the current provider
    return new Web3(window.ethereum);
  } else if (window.web3) {
    // Legacy dapp browsers
    return window.web3;
  } else {
    throw new Error("No Web3 provider detected. Please install MetaMask!");
  }
};

// Helper function to reconnect if connection is lost
export const reconnectWeb3 = async () => {
  try {
    console.log("Attempting to reconnect Web3...");
    const reliableWeb3 = await createWeb3WithRetry("opbnb");
    window.reliableWeb3 = reliableWeb3;
    console.log("Web3 reconnected successfully");
    return true;
  } catch (error) {
    console.error("Failed to reconnect Web3:", error);
    return false;
  }
};

export const disconnectWallet = async () => {
  try {
    // Close WebSocket connection if it exists
    if (window.reliableWeb3 && window.reliableWeb3.currentProvider && 
        window.reliableWeb3.currentProvider.connection) {
      window.reliableWeb3.currentProvider.connection.close();
    }
    
    // Clear the reliable Web3 instance
    window.reliableWeb3 = null;
    
    // Reset connection status
    isItConnected = false;
    
    console.log("Wallet disconnected successfully");
  } catch (error) {
    console.error("Error disconnecting wallet:", error);
  }
};
export const loadWeb3 = async () => {
  try {
    if (window.ethereum) {
      // Initialize Web3 with MetaMask provider
      const web3Instance = new Web3(window.ethereum);
      window.web3 = web3Instance;
      await window.ethereum.enable();

      // Get current chain ID
      const chainId = await window.ethereum.request({ method: 'eth_chainId' });
      const networkId = parseInt(chainId, 16);
      
      console.log("Current networkId:", networkId);
      
      switch (networkId.toString()) {
        case "204": // opBNB Mainnet
          isItConnected = true;
          console.log("Connected to opBNB Mainnet");
          break;
        default:
          console.log("Wrong network, switching to opBNB...");
          await handleNetworkSwitch("opbnb");
          isItConnected = false;
      }
      
      if (isItConnected === true) {
        // Get accounts first for faster UI feedback
        let accounts = await getAccounts();
        
        // Set up reliable Web3 in background (non-blocking)
        createWeb3WithRetry("opbnb", 3000).then((reliableWeb3) => {
          window.reliableWeb3 = reliableWeb3;
          console.log("🚀 Background RPC connection established");
        }).catch((error) => {
          console.warn("⚠️ Background RPC setup failed:", error.message);
        });
        
        return accounts[0];
      } else {
        let res = "Wrong Network";
        return res;
      }
    } else {
      let res = "No Wallet";
      return res;
    }
  } catch (error) {
    console.error("loadWeb3 error:", error);
    let res = "No Wallet";
    return res;
  }
};
